import React from "react";

export function Vazio({ texto }) {
  return (
    <div className="bg-card rounded-xl border p-12 text-center">
      <p className="text-muted-foreground">{texto}</p>
    </div>
  );
}

export function CardResumo({ label, value, icon: Icon, color = "text-primary" }) {
  return (
    <div className="bg-card rounded-xl border p-4">
      <div className="flex items-center justify-between mb-2">
        <p className="text-sm font-medium text-muted-foreground">{label}</p>
        <Icon className={`w-5 h-5 ${color}`} />
      </div>
      <p className="text-2xl font-bold tabular-nums">{value}</p>
    </div>
  );
}

// Estilo de tooltip dos gráficos (mesmo da tela antiga).
export const TOOLTIP_STYLE = {
  backgroundColor: "hsl(var(--card))",
  border: "1px solid hsl(var(--border))",
  borderRadius: "8px",
  color: "hsl(var(--card-foreground))",
};
